'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('preventDefault', function () {
    return function ($scope, $element) {
      angular.element($element).bind('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    };
  });
  return app;
};

require('angular');

/**
 * 阻止button click 冒泡
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/preventDefault.js
// module id = 145
// module chunks = 0